export function createFormId(reservationName: string, suffix: string) {
    return `${reservationName}_${suffix}`
}